export default __webpack_public_path__ + "static/media/left-arrow-filled.b55b9d10.svg";